<header class="fixed z-50 w-full bg-white">
  <div class="container flex max-h-16 items-center justify-between gap-2 py-4 lg:gap-4">
    <div class="logo relative flex items-center">
      <a
        class="ltr:mr-4 ltr:border-r ltr:border-r-slate-300 ltr:pr-4 rtl:ml-4 rtl:border-l rtl:border-l-slate-300 rtl:pl-4"
        routerLink=""
      >
        <svg-icon src="@assets/images/logo.svg" class="block w-20 lg:w-24"></svg-icon>
      </a>
      <span class="text-base font-medium text-slate-900">Terms of Service</span>
    </div>
    <div class="hidden items-center gap-4 md:flex">
      <button routerLink="/" class="btn btn-transparent btn-sm">
        <svg-icon class="btn-icon ltr:block rtl:hidden" src="@assets/images/icons/arrow-left.svg"></svg-icon>
        <svg-icon class="btn-icon ltr:hidden rtl:block" src="@assets/images/icons/arrow-right.svg"></svg-icon>
        <span>Home</span>
      </button>
      <button routerLink="/" class="btn btn-primary btn-sm">Browse Thkee Courses</button>
    </div>

    <div class="flex items-center gap-1 md:hidden">
      <button routerLink="/" class="btn btn-transparent btn-sm px-2">
        <svg-icon class="btn-icon" src="@assets/images/icons/home.svg"></svg-icon>
      </button>
      <button class="btn btn-transparent btn-sm px-2" (click)="toggle()">
        <svg-icon class="btn-icon" src="@assets/images/icons/bars-3.svg"></svg-icon>
      </button>
    </div>
  </div>
</header>

<section class="relative z-30 mb-16 w-full bg-white pt-24 md:pt-40">
  <div class="container relative">
    <div class="grid w-full grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-8">
        <router-outlet></router-outlet>
      </div>
      <div class="col-span-4 hidden pl-0 pr-0 md:block md:ltr:pl-10 md:rtl:pr-10">
        <ng-container *ngTemplateOutlet="navMenu"></ng-container>
      </div>
    </div>
  </div>
</section>

<div
  [ngClass]="isOpened ? 'w-full' : 'we-0'"
  class="fixed right-0 top-0 z-[900] h-full overflow-hidden bg-[rgba(0,0,0,0.3)]"
>
  <div
    [ngClass]="isOpened ? 'slide-right-out' : 'slide-right-in'"
    class="absolute right-0 top-0 z-30 flex h-full flex-col overflow-y-auto bg-white"
  >
    <div class="relative w-72">
      <div class="flex items-center justify-between p-4">
        <button routerLink="/" class="btn btn-primary btn-sm">Browse Thkee Courses</button>
        <button class="btn-icon" (click)="toggle()">
          <svg-icon src="@assets/images/icons/x-mark.svg"></svg-icon>
        </button>
      </div>
      <ng-container *ngTemplateOutlet="navMenu"></ng-container>
    </div>
  </div>
</div>

<ng-template #navMenu>
  <ul class="side-nav ltr:border-l ltr:border-l-slate-300 rtl:border-r rtl:border-r-slate-300">
    <li>
      <a
        class="hover:rtl:!border-r-primary-500 ltr:!border-r-0 rtl:!border-l-0 hover:rtl:!border-l-transparent"
        routerLinkActive="active"
        routerLink="/terms-of-use"
        >Terms of Use</a
      >
    </li>
    <li>
      <a
        class="hover:rtl:!border-r-primary-500 ltr:!border-r-0 rtl:!border-l-0 hover:rtl:!border-l-transparent"
        routerLinkActive="active"
        routerLink="/instructor-terms"
        >Instructor Terms</a
      >
    </li>
    <li>
      <a
        class="hover:rtl:!border-r-primary-500 ltr:!border-r-0 rtl:!border-l-0 hover:rtl:!border-l-transparent"
        routerLinkActive="active"
        routerLink="/privacy-policy"
        >Privacy Policy</a
      >
    </li>
    <li>
      <a
        class="hover:rtl:!border-r-primary-500 ltr:!border-r-0 rtl:!border-l-0 hover:rtl:!border-l-transparent"
        routerLinkActive="active"
        routerLink="/intellectual-property-policy"
        >Intellectual Property Policy</a
      >
    </li>
    <li>
      <a
        class="hover:rtl:!border-r-primary-500 ltr:!border-r-0 rtl:!border-l-0 hover:rtl:!border-l-transparent"
        routerLinkActive="active"
        routerLink="/credit-program"
        >Thkee Credits Program Terms & Conditions</a
      >
    </li>
    <li>
      <a
        class="hover:rtl:!border-r-primary-500 ltr:!border-r-0 rtl:!border-l-0 hover:rtl:!border-l-transparent"
        routerLinkActive="active"
        routerLink="/promotion-policy"
        >Promotions Policy</a
      >
    </li>
    <li>
      <a
        href="https://support.thkee.com/hc/en-us/articles/27439184160145"
        class="hover:rtl:!border-r-primary-500 ltr:!border-r-0 rtl:!border-l-0 hover:rtl:!border-l-transparent"
        target="_blank"
        >Contact Us</a
      >
    </li>
  </ul>
</ng-template>

<app-footer class="mt-auto"></app-footer>
